import { useExteriorSectionData } from '../useExteriorSection';

export const useTireSections = () => {
  const { subSections } = useExteriorSectionData('tires');
  return Object.values(subSections).filter(s => !s.name.includes('_plate'));
};
